import { render, staticRenderFns } from "./choosedevice.vue?vue&type=template&id=582e0c9e&"
import script from "./choosedevice.vue?vue&type=script&lang=ts&"
export * from "./choosedevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "choosedevice.vue"
export default component.exports